/**
 * Merges objects with provided depth
 * @param depth
 * @param args
 */ function shelfMerge(depth = 2, ...args) {
    return args.reduce((acc, arg)=>{
        if (!arg || typeof arg !== 'object') return acc;
        Object.entries(arg).forEach(([key, value])=>{
            if (typeof value !== 'object') {
                acc[key] = value;
                return;
            }
            if (Array.isArray(value)) {
                acc[key] = value;
                return;
            }
            if (depth > 1) {
                acc[key] = shelfMerge(depth - 1, acc[key], value);
                return;
            }
            acc[key] = value;
        });
        return acc;
    }, {});
}

export { shelfMerge };
//# sourceMappingURL=shelfMerge.js.map
